import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { NAV_GROUPS } from "./data";
import { Logo } from "./Logo";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end end"] });
  const y = useTransform(scrollYProgress, [0, 1], ["45%", "0%"]);

  return (
    <footer ref={ref} className="relative border-t border-white/10 pt-16 overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Logo />
          <p className="mt-5 max-w-xs text-sm text-slate-500">One network partner, from cabling to cloud.</p>
          <button onClick={() => scrollToId("contact")} data-testid="footer-link-contact" className="group mt-6 inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm text-slate-200 hover:border-cyan-300/60 hover:text-cyan-200 transition-colors">
            Book a free consultation <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:rotate-45" />
          </button>
        </div>
        <nav className="grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 lg:col-span-8" aria-label="Footer">
          {NAV_GROUPS.map((g, gi) => (
            <div key={g.id}>
              <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-cyan-300/80"><span className="text-slate-600 mr-2">0{gi + 1}</span>{g.label}</p>
              <ul className="mt-5 space-y-3.5">
                {g.items.map((it) => (
                  <li key={it.id}>
                    <button onClick={() => scrollToId(it.id)} data-testid={`footer-link-${it.id}`} className="text-left text-sm text-slate-400 hover:text-cyan-300 transition-colors">
                      {it.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </div>
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 mt-14 flex flex-col sm:flex-row justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
        <span>© {new Date().getFullYear()} Lunar Network Solutions · <a href="/privacy" data-testid="footer-link-privacy" className="hover:text-cyan-300 transition-colors">Privacy notice</a></span>
        <span className="flex items-center gap-2 text-emerald-400/80"><span className="h-1.5 w-1.5 rounded-full bg-emerald-400" /> Network status: operational</span>
      </div>
      <motion.p style={{ y }} className="select-none text-center font-display font-black leading-[0.8] tracking-[-0.06em] text-[26vw] text-outline-dim mt-6 -mb-[4vw]" aria-hidden>
        LUNAR
      </motion.p>
    </footer>
  );
};
